import React, { ReactNode } from 'react';

import {
  SelectInput,
  SelectField,
  AutocompleteInput,
  AutocompleteArrayInput,
  SelectArrayInput,
  Validator,
} from 'react-admin';

import SelectArrayField from './SelectArrayField';
import EditFieldLayout from '../components/layout/EditFieldLayout';

const getInputComponent = (autocomplete: boolean, multiple: boolean): React.ComponentType<{
  source: string;
  label: ReactNode;
  choices: { id: string; name:string }[];
  validate?: Validator | Validator[];
  color?: 'primary' | 'secondary';
  sx?: Record<string, unknown>;
  helperText?: boolean;
}> => {
  if (multiple) {
    if (autocomplete) return AutocompleteArrayInput;
    return SelectArrayInput;
  }

  if (autocomplete) return AutocompleteInput;
  return SelectInput;
};

const EditSelectInput = ({
  source,
  label,
  showEdit,
  choices,
  validate,
  autocomplete = false,
  multiple = false,
}: {
  showEdit: boolean;
  source: string;
  label: string;
  choices: { id: string; name:string }[];
  validate?: Validator | Validator[];
  autocomplete?: boolean;
  multiple?: boolean;
}) => {
  const InputComponent = getInputComponent(autocomplete, multiple);
  return (
    <EditFieldLayout
      source={source}
      label={label}
      showEdit={showEdit}
      inputElement={(
        <InputComponent
          color="secondary"
          choices={choices}
          label={false}
          source={source}
          validate={validate}
          helperText={false}
        />
      )}
      fieldElement={multiple ? (
        <SelectArrayField source={source} choices={choices} emptyText="-" />
      ) : (
        <SelectField source={source} choices={choices} emptyText="-" />
      )}
    />
  );
};

export default EditSelectInput;
